export default __webpack_public_path__ + "static/media/part+1+github-1320568339880199515.77a97279.png";